/**
 * Solana program constants and helpers.
 * Update PROGRAM_ID after running `anchor deploy`.
 */
export const PROGRAM_ID = "A6KXpSqEwEUJyQwFcgM2fSptHjmXHUMyijb2ihAc2hjd";
export const BACKEND_URL =
  (process.env.NEXT_PUBLIC_BACKEND_URL ?? "http://localhost:8000").replace(/\/$/, "");

export function shortenAddress(address: string, chars = 4): string {
  return `${address.slice(0, chars)}...${address.slice(-chars)}`;
}
